import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { StorageService } from '../../../common/services/storage.service';

export const addTokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {

  const storageService = inject(StorageService);

  let apiKey = environment.apiKeys.tables;
  if (req.url.includes('/beneficios')) {
    apiKey = environment.apiKeys.benefits;
  } else if (req.url.includes('/orders')) {
    apiKey = 'API_KEY_ORDENES';
  } else if (req.url.includes('/socios')) {
    apiKey = environment.apiKeys.status;
  }

  const headers: Record<string, string> = {
    apikey: apiKey,
    'Content-Type': 'application/json'
  };

  const isLoginRequest = req.url.includes('/auth/lap/login');

  const token = storageService.token;
  if (token && !isLoginRequest) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const modifiedReq = req.clone({ setHeaders: headers });
  return next(modifiedReq);
};

